import { fade } from '@material-ui/core/styles/colorManipulator';

export const toolbarStyles = theme => {

    const boxShadowColor = theme.palette.background.black;
    const shadow = [0, 3, 5, -1, fade(boxShadowColor, 0.2)];

    return {
        root: {
            borderRadius: 1,
        },
        toolbar: {
            backgroundColor: theme.palette.background.light,
            color: theme.palette.text.primary,
            boxShadow: [shadow],
            border: `1px solid ${theme.palette.divider}`,
            flexWrap: 'wrap'
        },
        divider: {
            height: theme.spacing.unit * 3,
            margin: theme.spacing.unit,
            borderRight: `2px solid ${theme.palette.divider}`
        },
        selected: {
            backgroundColor: theme.palette.divider,
            boxShadow: [shadow],

        },
        actions: {
            backgroundColor: theme.palette.background.white,
            margin: '0',
            padding: '10px 20px'
        }
    }
}

export const dialogStyles = theme => ({
    header: {
        display: 'flex',
        alignItems: 'center',
        background: theme.palette.primary.main,
        color: theme.palette.text.white,
        padding: '20px 40px'
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-evenly',
        paddingTop: '24px'
    },
    actions: {
        borderTop: `1px solid ${theme.palette.divider}`,
        margin: '0',
        padding: '10px 20px'
    },
    formContainer: {
        padding: '0 20px'
    }

});
